import { useState } from "react";
import { motion } from "framer-motion";
import { LayoutGrid } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

const PROJECTS = [
  {
    title: "Struktur Baja & Atap Arena Olahraga",
    category: "Konstruksi Bangunan",
    image: "/projects/p1.jpg",
    alt: "Struktur baja lengkung dan atap arena olahraga indoor hasil pengerjaan PT. Prime Karya Mandiri",
  },
  {
    title: "Pembangunan Lapangan Padel Indoor",
    category: "Konstruksi Bangunan",
    image: "/projects/p2.jpg",
    alt: "Lapangan padel indoor dengan rangka baja dan lantai biru hasil pengerjaan PT. Prime Karya Mandiri",
  },
  {
    title: "Interior Kafe & Area Komersial",
    category: "Pekerjaan Interior",
    image: "/projects/p3.jpg",
    alt: "Interior kafe dengan plafon kain dan furnitur kayu hasil pengerjaan PT. Prime Karya Mandiri",
  },
];

export const Projects = () => {
  const [note, setNote] = useState(false);

  return (
    <section id="proyek" className="bg-white" aria-label="Proyek pilihan">
      <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-12 lg:py-28">
        <Reveal className="max-w-2xl">
          <Eyebrow>Proyek Pilihan</Eyebrow>
          <h2 className="text-balance font-heading text-3xl font-extrabold leading-tight tracking-tight text-navy sm:text-4xl">
            Dokumentasi Pekerjaan{" "}
            <span className="italic text-orange-500">Kami di Lapangan</span>
          </h2>
          <p className="mt-5 text-base leading-relaxed text-slate-600">
            Sebagian hasil pekerjaan PT. Prime Karya Mandiri — dari struktur
            baja arena olahraga hingga penyelesaian interior ruang komersial.
          </p>
        </Reveal>

        <div
          data-testid="projects-grid"
          className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3"
        >
          {PROJECTS.map((project, i) => (
            <Reveal key={project.title} delay={(i % 3) * 0.08} className="h-full">
              <motion.article
                data-testid={`project-card-${i + 1}`}
                whileHover="hover"
                initial="rest"
                animate="rest"
                className="group relative h-full overflow-hidden rounded-2xl bg-navy shadow-lg shadow-navy/15"
              >
                <motion.img
                  variants={{ rest: { scale: 1 }, hover: { scale: 1.06 } }}
                  transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                  src={project.image}
                  alt={project.alt}
                  className="aspect-[4/3] w-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-dark/95 via-navy/25 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-5 sm:p-6">
                  <p className="text-xs font-bold uppercase tracking-[0.18em] text-orange-400">
                    {project.category}
                  </p>
                  <h3 className="mt-1.5 font-heading text-lg font-bold text-white">
                    {project.title}
                  </h3>
                </div>
              </motion.article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15} className="mt-12 text-center">
          <button
            type="button"
            data-testid="projects-cta-all"
            onClick={() => setNote(true)}
            className="inline-flex items-center gap-2.5 rounded-full border-2 border-navy px-8 py-3.5 text-sm font-bold text-navy transition-[background-color,color,transform] duration-300 hover:-translate-y-0.5 hover:bg-navy hover:text-white"
          >
            <LayoutGrid className="h-4 w-4" aria-hidden="true" />
            Lihat Semua Proyek
          </button>
          {note && (
            <p
              data-testid="projects-archive-note"
              className="mt-4 text-sm font-medium text-slate-500"
              role="status"
            >
              Arsip lengkap proyek akan segera tersedia. Hubungi kami untuk
              melihat dokumentasi pekerjaan lainnya.
            </p>
          )}
        </Reveal>
      </div>
    </section>
  );
};
